import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const LEVEL_CLASSES = [
  'bg-gray-100 dark:bg-gray-800',
  'bg-green-200 dark:bg-green-900',
  'bg-green-400 dark:bg-green-600',
  'bg-green-600 dark:bg-green-400',
  'bg-green-800 dark:bg-green-300',
];

const DAY_LABELS = ['', 'Mon', '', 'Wed', '', 'Fri', ''];

function getLevel(count) {
  if (count === 0) return 0;
  if (count <= 2) return 1;
  if (count <= 5) return 2;
  if (count <= 9) return 3;
  return 4;
}

export default function GitHubChart() {
  const [weeks, setWeeks] = useState([]);
  const [total, setTotal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get('/github-contributions')
      .then(res => {
        const allWeeks = res.data.weeks || [];
        setWeeks(allWeeks.slice(-26)); // last 6 months
        setTotal(res.data.totalContributions ?? null);
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-24">
        <div className="w-6 h-6 border-2 border-gray-300 dark:border-gray-600 border-t-black dark:border-t-white rounded-full animate-spin" />
      </div>
    );
  }

  if (error || weeks.length === 0) return null;

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-3">
        <a
          href="https://github.com/danielwait2"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs font-semibold uppercase tracking-widest text-gray-400 dark:text-gray-500 hover:text-gray-900 dark:hover:text-white transition-colors"
        >
          GitHub Activity
        </a>
        {total !== null && (
          <span className="text-xs text-gray-400 dark:text-gray-500">
            {total.toLocaleString()} commits this year
          </span>
        )}
      </div>

      <div className="overflow-x-auto w-full pb-1">
      <div className="flex gap-0.5 min-w-max">
        {/* Day-of-week labels */}
        <div className="flex flex-col gap-0.5 mr-1 shrink-0">
          {DAY_LABELS.map((label, i) => (
            <div key={i} className="h-3 flex items-center">
              <span className="text-[9px] text-gray-400 dark:text-gray-600 leading-none w-5">{label}</span>
            </div>
          ))}
        </div>

        {/* Contribution cells */}
        {weeks.map((week, wi) => (
          <div key={wi} className="flex flex-col gap-0.5 shrink-0">
            {week.contributionDays.map((day, di) => (
              <div
                key={di}
                title={`${day.date}: ${day.contributionCount} commit${day.contributionCount !== 1 ? 's' : ''}`}
                className={`w-3 h-3 rounded-sm ${LEVEL_CLASSES[getLevel(day.contributionCount)]}`}
              />
            ))}
          </div>
        ))}
      </div>
      </div>
    </div>
  );
}
